import { render, staticRenderFns } from "./JustificationStatusMessage.vue?vue&type=template&id=48183110&scoped=true"
import script from "./JustificationStatusMessage.vue?vue&type=script&lang=js"
export * from "./JustificationStatusMessage.vue?vue&type=script&lang=js"
import style0 from "./JustificationStatusMessage.vue?vue&type=style&index=0&id=48183110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48183110",
  null
  
)

export default component.exports